import React from "react";
import { useLocation } from "react-router-dom";
import { Container } from "react-bootstrap";
import magentaEnerexLogo from "../assets/images/magenta-enerex.svg";
import DataHubLogo from "@enerex/unified-ui-react/logos/DataHubLogo";

const PublicLayout = ({ children }) => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const hideHeaderLogin =
    location.pathname === "/signup" ||
    location.pathname === "/signup/email-verification";
  const hideHeader = hideHeaderLogin;

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f5f6fa",
      }}
    >
      {/* Full width header with logo */}
      {!hideHeader && (
        <header style={{ width: "100%", padding: "15px 0", backgroundColor: "#f5f6fa", borderBottom: "1px solid #e5e5e5" }}>
          <Container fluid>
            <div style={{ position: "relative", display: "flex", alignItems: "center", justifyContent: "flex-end", minHeight: 40 }}>
              {/* Center logo */}
              <a
                href="/"
                style={{
                  position: "absolute",
                  left: "50%",
                  transform: "translateX(-50%)",
                  textDecoration: "none",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <DataHubLogo aria-label="DataHub" style={{ height: 40, width: "auto" }} />
              </a>

              {/* Right action */}
              <button
                onClick={() => {
                  window.open("/signup", "_blank", "noopener,noreferrer");
                }}
                style={{
                  backgroundColor: "#131C45",
                  color: "#fff",
                  border: "1px solid #131C45",
                  borderRadius: "0px",
                  padding: "10px 20px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontFamily: "sans-serif",
                  fontWeight: "500",
                  transition: "opacity 0.2s"
                }}
                onMouseEnter={(e) => (e.target.style.opacity = "0.9")}
                onMouseLeave={(e) => (e.target.style.opacity = "1")}
              >
                Sign up
              </button>
            </div>
          </Container>
        </header>
      )}

      {/* Main content */}
      <main style={{ flex: 1, width: "100%", backgroundColor: "#f5f6fa" }}>
        <Container fluid>
          {children}
        </Container>
      </main>

      {/* Full width footer */}
      <footer
        style={{
          width: "100%",
          padding: "10px 0",
          backgroundColor: "#fff",
          borderTop: "1px solid #e5e5e5",
          marginTop: "auto",
        }}
      >
        <Container fluid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 16,
              padding: "0 8px",
            }}
          >
            <div style={{ color: "#6c757d", fontSize: 12 }}>
              <div style={{ fontWeight: 600, color: "#131c45" }}>
                Need more information?
              </div>
              <div>
                Speak with our experts and get connected to DataHub
              </div>
            </div>

            <div style={{ color: "#6c757d", fontSize: 12, whiteSpace: "nowrap" }}>
              <a
                href="https://enerex.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#6c757d", textDecoration: "none" }}
              >
                Powered by{" "}
                <img
                  src={magentaEnerexLogo}
                  alt="Enerex"
                  style={{ height: 16, width: "auto", verticalAlign: "middle" }}
                />
              </a>
            </div>
          </div>
        </Container>
      </footer>
    </div>
  );
};

export default PublicLayout;
